const Malayalam = {
  //COMMON
  nameRequired: "പേര് ആവശ്യമാണ്.",
  firstNameRequired: "ആദ്യ പേര് ആവശ്യമാണ്.",
  lastNameRequired: "അവസാന പേര് ആവശ്യമാണ്.",
  emailRequired: "ഇമെയിൽ ആവശ്യമാണ്.",
  phoneRequired: "ഫോൺ നമ്പർ ആവശ്യമാണ്.",
  genderRequired: "ലിംഗം ആവശ്യമാണ്.",
  dobRequired: "ജനന തീയതി ആവശ്യമാണ്.",
  firstNamelength: "ആദ്യ പേര് കുറഞ്ഞത് 3 അക്ഷരങ്ങളെങ്കിലും ഉണ്ടായിരിക്കണം.",

  experienceRequired: "അനുഭവം ആവശ്യമാണ്.",
  suggestionRequired: "നിർദ്ദേശം ആവശ്യമാണ്.",
  onlyAlphabetsAllowed: "അക്ഷരങ്ങളും ഇടവിടങ്ങളും മാത്രമേ അനുവദിക്കൂ.",

  //PROFILE
  pincodeRequired: "സാധുവായ 6 അക്ക പിൻകോഡ് ആവശ്യമാണ്.",
  stateRequired: "സംസ്ഥാനം ആവശ്യമാണ്.",
  districtRequired: "ജില്ല ആവശ്യമാണ്.",
  cityRequired: "നഗരം/ഗ്രാമം ആവശ്യമാണ്.",
  addressRequired: "വിലാസം ആവശ്യമാണ്.",
  religionRequired: "മതം ആവശ്യമാണ്.",
  templeFrequencyRequired: "ക്ഷേത്ര സന്ദർശന തീവ്രത ആവശ്യമാണ്.",
  languageRequired: "ഭാഷ ആവശ്യമാണ്.",
  phoneTenDigits: "ഫോൺ നമ്പർ 10 അക്കമായിരിക്കണം.",
  phonestarts:"സംഖ്യ 0-ൽ ആരംഭിക്കരുത്.",
  aadharInvalid: "ആധാർ നമ്പർ 12 അക്കമായിരിക്കണം.",
  passportInvalid:
    "പാസ്‌പോർട്ട് നമ്പർ 1 അക്ഷരവും 7 അക്കവും ആയിരിക്കണം (ഉദാ: K1234567).",
  firstNameInvalid: "ആദ്യ പേര് അക്ഷരങ്ങളും സ്പേസുകളും മാത്രമേ ഉൾക്കൊള്ളൂ.",
  lastNameInvalid: "അവസാന പേര് അക്ഷരങ്ങളും സ്പേസുകളും മാത്രമേ ഉൾക്കൊള്ളൂ.",

  // PASSWORD
  currentPasswordRequired: "നിലവിലെ പാസ്വേഡ് ആവശ്യമാണ്.",
  newPasswordRequired: "പുതിയ പാസ്വേഡ് ആവശ്യമാണ്.",
  confirmPasswordRequired: "പാസ്വേഡ് സ്ഥിരീകരണം ആവശ്യമാണ്.",
  currentPasswordInvalid:
    "നിലവിലെ പാസ്വേഡ് കുറഞ്ഞത് 8 അക്കരങ്ങളുള്ളതും, ഒരു വലിയ അക്ഷരം, ഒരു ചെറിയ അക്ഷരം, ഒരു സംഖ്യ, ഒരു പ്രത്യേക പ്രതീകം എന്നിവ ഉൾക്കൊള്ളുന്നതായിരിക്കണം.",
  newPasswordInvalid:
    "പുതിയ പാസ്വേഡ് കുറഞ്ഞത് 8 അക്കരങ്ങളുള്ളതും, ഒരു വലിയ അക്ഷരം, ഒരു ചെറിയ അക്ഷരം, ഒരു സംഖ്യ, ഒരു പ്രത്യേക പ്രതീകം എന്നിവ ഉൾക്കൊള്ളുന്നതായിരിക്കണം.",
  confirmPasswordInvalid:
    "സ്ഥിരീകരിക്കുന്ന പാസ്വേഡ് കുറഞ്ഞത് 8 അക്കരങ്ങളുള്ളതും, ഒരു വലിയ അക്ഷരം, ഒരു ചെറിയ അക്ഷരം, ഒരു സംഖ്യ, ഒരു പ്രത്യേക പ്രതീകം എന്നിവ ഉൾക്കൊള്ളുന്നതായിരിക്കണം.",
  passwordsNotMatch:
    "പുതിയ പാസ്വേഡ് സ്ഥിരീകരിക്കുന്ന പാസ്വേഡ് പൊരുത്തപ്പെടുന്നില്ല.",
    emojiNotAllowed:"പാസ്‌വേഡിൽ ഇമോജികൾ അനുവദനീയമായിട്ടില്ല.",
  incorrectCurrentPassword: "നിങ്ങൾ നൽകിയ നിലവിലെ പാസ്വേഡ് തെറ്റാണ്.",
  sameAsCurrentPassword:
    "പുതിയ പാസ്വേഡ് നിലവിലെ പാസ്വേഡിനോട് സമമാണ് ആകാൻ കഴിയില്ല.",

  //IMAGE
  fileTooLarge: "ഫയലിന്റെ വലുപ്പം 2MB-നെ കവിയരുത്.",
  invalidFileType:
    "അസാധുവായ ഫയൽ തരം. ദയവായി JPG/JPEG അല്ലെങ്കിൽ PNG ചിത്രം അപ്‌ലോഡ് ചെയ്യുക.",
  imageUploadFailed: "ഇമേജ് അപ്‌ലോഡ് പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
};

export default Malayalam;
